import { queryOptions } from "@tanstack/react-query";
import { salesApi } from "./api.ts";

// Ключи продаж начинаются с "sales": после действия экран сбрасывает их разом.
export const SALES = ["sales"] as const;

export const salesOrdersQuery = queryOptions({ queryKey: [...SALES, "orders"], queryFn: salesApi.orders });
export const shipTasksQuery = queryOptions({ queryKey: [...SALES, "tasks"], queryFn: salesApi.tasks });
export const customersQuery = queryOptions({ queryKey: [...SALES, "customers"], queryFn: salesApi.customers, staleTime: 5 * 60_000 });

export const salesOrderQuery = (id: string) =>
  queryOptions({ queryKey: [...SALES, "order", id], queryFn: () => salesApi.order(id), retry: false });

export const shortageQuery = (id: string) => queryOptions({ queryKey: [...SALES, "shortage", id], queryFn: () => salesApi.shortage(id) });

export const candidatesQuery = (id: string, no: number) =>
  queryOptions({ queryKey: [...SALES, "candidates", id, no], queryFn: () => salesApi.candidates(id, no) });
